export default __webpack_public_path__ + "static/media/NathanHoebeke.e906f8bc.webp";